
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/practice-areas/category/[category]",
      function () {
        return require("private-next-pages/practice-areas/category/[category].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/practice-areas/category/[category]"])
      });
    }
  